export interface CampaignTableFiltersProps {
  onSubmit: () => void
}

export type VoohCampaignsFiltersForm = VoohCampaignsFilters & VoohCampaignsFiltersMeta

export interface VoohCampaignsFilters {
  cities: string[]
  agencies: string[]
  mediaFormats: string[]
  startDateFrom: string
  startDateTo: string
  endDateFrom: string
  endDateTo: string
  statuses: string[]
  text: string
  buildings: string[]
  brandOrNetworkSelected?: string[]
}

export interface VoohCampaignsFiltersMeta {
  citiesAll: VoohCampaignsFilters['cities']
  agenciesAll: VoohCampaignsFilters['agencies']
  mediaFormatsAll: VoohCampaignsFilters['mediaFormats']
  statusesAll: VoohCampaignsFilters['statuses']
  buildingsAll: VoohCampaignsFilters['buildings']
}

export const voohFiltersDefault: VoohCampaignsFilters = {
  agencies: [],
  cities: [],
  endDateFrom: '',
  endDateTo: '',
  mediaFormats: [],
  startDateFrom: '',
  startDateTo: '',
  statuses: [],
  text: '',
  buildings: [],
  brandOrNetworkSelected: [],
}

export const voohFiltersFormDefault: VoohCampaignsFiltersForm = {
  ...voohFiltersDefault,
  citiesAll: [],
  agenciesAll: [],
  mediaFormatsAll: [],
  statusesAll: [],
  buildingsAll: [],
}
